"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericDynamicLoadManager = void 0;
const dynamicLoadManager_1 = require("../../../dynamicLoad/dynamicLoadManager");
class GenericDynamicLoadManager extends dynamicLoadManager_1.DynamicLoadManagerBase {
}
exports.GenericDynamicLoadManager = GenericDynamicLoadManager;
//# sourceMappingURL=interfaces.js.map